import { render, staticRenderFns } from "./userBill.vue?vue&type=template&id=10bfbd46&scoped=true"
import script from "./userBill.vue?vue&type=script&lang=js"
export * from "./userBill.vue?vue&type=script&lang=js"
import style0 from "./userBill.vue?vue&type=style&index=0&id=10bfbd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfbd46",
  null
  
)

export default component.exports